import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Checkbox, Input, Select, Radio } from 'antd';
import styles from './index.module.less';
// import countryFlag from '@/common/assets/images/emojioneflag.svg';

import './index.module.css';
import { Message, Icon } from 'semantic-ui-react';
import RegisterLogo from '@/common/assets/images/RegisterLogo.png';
import martrimonyLogo from '@/common/assets/images/martrimonyLogo.png';

const RegisterPage = ({ country_codes, onCheckboxChange }) => {
  const [errorMsg] = useState('');

  const [agreeTerms, setAgreeTerms] = useState(false);
  const [receiveEmails, setReceiveEmails] = useState(false);

  // ✅ Check if both checkboxes are checked
  // const isButtonEnabled = agreeTerms && receiveEmails;

  // ✅ Trigger callback whenever checkbox states change
  useEffect(() => {
    onCheckboxChange(agreeTerms && receiveEmails);
  }, [agreeTerms, receiveEmails, onCheckboxChange]);
  // const handleCheckboxChange = (name, checked) => {
  //   if (name === 'agreeTerms') setAgreeTerms(checked);
  //   if (name === 'receiveEmails') setReceiveEmails(checked);

  //   // ✅ Notify Parent Component
  //   onCheckboxChange(agreeTerms && receiveEmails);
  // };

  return (
    <>
      <Row className={styles.mainContainerStyle}>
        <Col xs={24} xl={11} lg={11} md={24} sm={6} className={styles.mainlogo}>
          <img className={`${styles.left_logo}`} src={RegisterLogo} />
          <div className={styles.textstyles}>
            <h2>THE TALE OF</h2>
            <h1>TWO</h1>
          </div>
        </Col>

        <Col
          xs={24}
          xl={13}
          lg={13}
          sm={6}
          md={24}
          className={styles.sideheader}
        >
          <div className={styles.headerload}>
            <img
              src={martrimonyLogo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>
          <div
            className={styles.sideheader1}
            // style={{ backgroundColor: '#f9f1dc' }}
          >
            <h1 className={styles.headingsmall}>Find Your</h1>
            <h1 className={styles.someonestyles}>Special someone</h1>
          </div>

          <div className={styles.right_outer_container}>
            <div className={styles.row}>
              <Form.Item
                label="First Name (Bride/Bridegroom)"
                name={['registerPage', 'firstName']}
                className={styles.formItem}
                rules={[{ required: true, message: 'Please enter first name' }]}
              >
                <Input
                  placeholder="Enter first name"
                  className={styles.input}
                />
              </Form.Item>

              <Form.Item
                label="Last Name (Bride/Bridegroom)"
                name={['registerPage', 'lastName']}
                rules={[
                  { required: true, message: 'Please enter your last name' }
                ]}
                className={styles.formItem}
              >
                <Input placeholder="Enter last name" className={styles.input} />
              </Form.Item>
            </div>

            {/* Gender & Mobile Number */}
            {/* <h3 className={styles.sectionTitle}>Disabilities</h3> */}
            <div className={styles.row}>
              <Form.Item
                name={['registerPage', 'gender']}
                label="Gender"
                rules={[
                  {
                    required: true,
                    message: 'Please select gender'
                  }
                ]}
              >
                <Radio.Group>
                  <Row gutter={[24]} className={styles.radiobuttons}>
                    <Col span={12}>
                      <Radio value="male">Male</Radio>
                    </Col>
                    <Col span={12}>
                      <Radio value="female">Female</Radio>
                    </Col>
                  </Row>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label="Phone Number"
                required
                // name="phone"
                // rules={[
                //   { required: true, message: 'Please enter your phone number' }
                // ]}
                className={styles.fullWidthItem}
              >
                <Input.Group compact className={styles.customInputContainer}>
                  <Form.Item
                    name={['registerPage', 'countryCode']}
                    noStyle
                    // initialValue="+91"
                    initialValue={1}
                  >
                    <Select
                      style={{ width: '30%' }}
                      showSearch
                      placeholder="Select country code"
                      // placeholder={
                      //   <div style={{ display: 'flex', alignItems: 'center' }}>
                      //     <img
                      //       src={countryFlag}
                      //       alt="Flag"
                      //       style={{
                      //         width: '30px',
                      //         height: '20px'
                      //       }}
                      //     />
                      //     +91
                      //   </div>
                      // }
                      className="custom-select"
                      optionFilterProp="children"
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      } // Ensures correct styling
                      dropdownStyle={{ borderRadius: '8px' }} // Apply radius to dropdown
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {country_codes?.length
                        ? country_codes?.map((code, index) => {
                            return (
                              <option value={code?.id} key={index}>
                                {code?.country_code}
                              </option>
                            );
                          })
                        : ''}
                    </Select>
                  </Form.Item>
                  <span className={styles.divider}>|</span>
                  <Form.Item
                    name={['registerPage', 'phoneNumber']}
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: 'Please enter a valid phone number'
                      },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: 'Phone number must be up to 10 digits'
                      }
                    ]}
                  >
                    <Input
                      placeholder="Enter phone number"
                      type="tel"
                      maxLength={10}
                      // onChange={(e) => {
                      //   const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                      //   form.setFieldsValue({
                      //     registerPage: { phoneNumber: numericValue }
                      //   });
                      // }}
                      style={{
                        width: '110%',
                        // marginLeft: '-5px',
                        height: '36.33px'
                      }}
                      // , padding: '5px 0 5px 10px'
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </div>
            <Form.Item
              label="E-mail"
              name={['registerPage', 'email']}
              rules={[{ required: false, message: 'Please enter your email' }]}
              className={styles.fullWidthItem}
            >
              <Input placeholder="Enter e-mail" className={styles.input} />
            </Form.Item>

            {/* Checkboxes */}
            <Form.Item
              className={styles.checkboxItem}
              name={['registerPage', 'agreeTerms']}
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject('Please agree to the Terms & Conditions')
                }
              ]}
            >
              <Checkbox
                className={styles.checkbox}
                // onChange={(e) => onCheckboxChange(e.target.checked)} // ✅ Trigger Parent Callback
                // onChange={(e) =>
                //   handleCheckboxChange('agreeTerms', e.target.checked)
                // }
                onChange={(e) => setAgreeTerms(e.target.checked)}
              >
                {/* I agree to the <b>Terms & Conditions</b> and{' '}
                <b>Privacy Policy</b> */}
                I agree to the{' '}
                <a
                  href="/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.policies}
                >
                  <b>Terms & Conditions</b>
                </a>{' '}
                and{' '}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.policies}
                >
                  <b>Privacy Policy</b>
                </a>
                .
              </Checkbox>
            </Form.Item>

            <Form.Item
              className={styles.checkboxItem}
              name={['registerPage', 'receiveEmails']}
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          'Please agree to receive emails to proceed.'
                        )
                }
              ]}
            >
              <Checkbox
                className={styles.checkbox}
                // onChange={(e) =>
                //   handleCheckboxChange('receiveEmails', e.target.checked)
                // }
                onChange={(e) => setReceiveEmails(e.target.checked)}
              >
                Receive emails on latest offers & membership perks.
              </Checkbox>
            </Form.Item>
          </div>
        </Col>
      </Row>
      <div>
        {errorMsg && (
          <Message negative>
            <Icon name="warning" />
            {errorMsg}
          </Message>
        )}
      </div>
    </>
  );
};

export default RegisterPage;
